export default "__VITE_ASSET__DjvqdKzd__"